/**
 * BoQ (Bill of Quantities) status constants.
 * These mirror the values stored in the `boq_status` column on the backend `lvs` table.
 *
 *   null       – no BoQ has been saved yet for this LV
 *   DRAFT      – at least one draft save has been performed; positions are NOT yet synced
 *   FINALIZED  – saved with finalize=true; lv_positions are in sync, editing is locked
 */
export const BOQ_STATUS = {
	DRAFT: "draft",
	FINALIZED: "finalized",
};
